export enum BuildingServices {
    BRUNATA_WEBMON_SEMIMONTHLY_DATA_CSV = 1,
    BRUNATA_WEBMON_SEMIMONTHLY_DATA_KTP = 2,
    BRUNATA_WEBMON_SEMIMONTHLY_DATA = 3,
    MYBRUNATA = 5, // Merged from BRUNATA_CONSUMER_APP and RESIDENT_PORTAL
    BRUNATA_VISUAL_SERVICENAME = 7,
    REPORT_AGENT = 8,
    MINENERGI2 = 10,
    BRUNATA_HOUSING_SERVICENAME = 11,
    PROSERVICE_FOR_HCA = 12,
    PROSERVICE_FOR_WATER = 13,
    PROSERVICE_FOR_ENERGY = 14,
    PROSERVICE_FOR_ELECTRICITY = 15,
    VISIT_NO_MORE = 16,
    DOMEA_AGREEMENT_2019 = 17,
    VIBO_AGREEMENT_2018 = 18,
    DRIVE_BY_UPGRADE = 19,
    PROSERVICE_FOR_HYGRO = 21,
    SALUS_SOUTHERN_DENMARK_2020 = 22,
    RINGGAARDEN_AARHUS_2020 = 23,
    CAMPAIGN_1005 = 24,
    MINOL_MIGRATION = 25,
    FINANCING = 26,
    EED_EMAIL_NOTIFICATIONS = 27,
    BRUNATA_ONLINE_SERVICES = 42,
    ONLINE_REPORTING = 43,
    REGISTER_MOVE_OUTS = 44,
    WEBARCHIVE = 46,
    REMOTE_READING_DATA = 47,
    COMPASS = 49,
    CONTROL_SYSTEM_WATER = 50,
    CONTROL_SYSTEM_ENERGY = 51,
    EVENTS_AGENTS_AND_ALARMS = 52,
    BRUNATA_PROPERTY_API = 53,
    RELEASE_BILLS = 54,
    DAILY_READINGS_API = 55,
    PROSERVICE_FOR_SMOKE = 56,
    PROSERVICE_FOR_PULSE_DATA = 57,
    CONNECTIVITY_FEE_SMALL = 58,
    CONNECTIVITY_FEE_LARGE = 59,
    INDOOR_CLIMATE_MONITORING = 62,
    LEAKAGE_MONITORING = 63,
    SMOKE_DETECTOR_MONITORING = 64,
    RUNNING_TOILET_MONITORING = 65,
    LYSE = 82,
    UNIK = 83,
    HOUSING_INTEGRATION = 85,
    MAP_OF_DEVICES = 86,
    METER_PHOTO = 87,
    HOURLY_CONSUMPTION = 89,
    ASE_QUICK_EXPORTS = 90,
    ASE_CUSTOMIZED_EXPORTS = 91,
    ASE_SAVED_EXPORTS = 92,
    ASE_ADVANCED_DELIVERY = 93,
}
